import { forwardRef, useState } from "react";
import { DatePicker } from "antd";
import classNames from "classnames";
import type { DatePickerProps, GetRef } from "antd";
import { AppCheckbox } from "../AppCheckbox";
import styles from "./styles.module.scss";

type DatePickerRef = GetRef<typeof DatePicker>;

export type AppDatePickerProps = {
  hideOnlyYearCheckbox?: boolean;
  isOnlyYearPicker?: boolean;
  customOnChange?: () => void;
} & DatePickerProps;

export const AppDatePicker = forwardRef<DatePickerRef, AppDatePickerProps>(
  ({ className, isOnlyYearPicker = false, hideOnlyYearCheckbox = true, ...props }, ref) => {
    const [yearHide, setYearHide] = useState<boolean>(isOnlyYearPicker);

    return (
      <DatePicker
        ref={ref}
        popupClassName={classNames({ [styles["year-hide"]]: yearHide })}
        className={classNames(styles.picker, className)}
        format={{
          type: "mask",
          format: yearHide ? "DD-MM" : "DD-MM-YYYY",
        }}
        onChange={() => {
          props.customOnChange?.();
        }}
        renderExtraFooter={() => {
          if (hideOnlyYearCheckbox) return;
          return (
            <div className={styles["hide-year-checkbox-container"]}>
              <AppCheckbox
                defaultChecked={yearHide}
                onChange={(e) => setYearHide(e.target.checked)}
              >
                <span className={styles["hide-year-content"]}>Without year</span>
              </AppCheckbox>
            </div>
          );
        }}
        {...props}
      />
    );
  },
);

export const AppYearDatePicker = forwardRef<DatePickerRef, AppDatePickerProps>(
  ({ className, ...props }, ref) => {
    return (
      <DatePicker.YearPicker
        ref={ref}
        format={"YYYY"}
        className={classNames(styles.picker, className)}
        onChange={() => {
          props.customOnChange?.();
        }}
        {...props}
      />
    );
  },
);
